var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSocialInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19,
    stroke: "#C4FB71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4339 14.3633C16.3475 14.3633 13.7901 16.8765 13.7901 20.007C13.7901 23.1375 16.3034 25.6508 19.4339 25.6508C22.5644 25.6508 25.0776 23.0934 25.0776 20.007C25.0776 16.9206 22.5203 14.3633 19.4339 14.3633ZM19.4339 23.6225C17.4497 23.6225 15.8183 21.9911 15.8183 20.007C15.8183 18.0229 17.4497 16.3915 19.4339 16.3915C21.418 16.3915 23.0494 18.0229 23.0494 20.007C23.0494 21.9911 21.418 23.6225 19.4339 23.6225Z",
    fill: "#C4FB71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2981 15.5097C26.0043 15.5097 26.5767 14.9372 26.5767 14.2311C26.5767 13.5249 26.0043 12.9524 25.2981 12.9524C24.5919 12.9524 24.0194 13.5249 24.0194 14.2311C24.0194 14.9372 24.5919 15.5097 25.2981 15.5097Z",
    fill: "#C4FB71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6049 10.9242C27.4585 9.73374 25.8272 9.11646 23.9753 9.11646H14.8924C11.0564 9.11646 8.49911 11.6738 8.49911 15.5098V24.5486C8.49911 26.4445 9.1164 28.0759 10.351 29.2664C11.5414 30.4128 13.1287 30.9859 14.9365 30.9859H23.9312C25.8272 30.9859 27.4145 30.3687 28.5608 29.2664C29.7513 28.12 30.3686 26.4886 30.3686 24.5926V15.5098C30.3686 13.6579 29.7513 12.0706 28.6049 10.9242ZM28.4286 24.5926C28.4286 25.9595 27.9436 27.0618 27.1499 27.8113C26.3563 28.5609 25.254 28.9577 23.9312 28.9577H14.9365C13.6138 28.9577 12.5115 28.5609 11.7178 27.8113C10.9242 27.0177 10.5273 25.9154 10.5273 24.5486V15.5098C10.5273 14.187 10.9242 13.0847 11.7178 12.2911C12.4674 11.5415 13.6138 11.1447 14.9365 11.1447H24.0194C25.3421 11.1447 26.4444 11.5415 27.2381 12.3351C27.9877 13.1288 28.4286 14.2311 28.4286 15.5098V24.5926Z",
    fill: "#C4FB71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialInstagram);
export default __webpack_public_path__ + "static/media/icon-social-instagram.786cc55ea59f9fb13a8cb001791b5042.svg";
export { ForwardRef as ReactComponent };